// NODE_ENV=development
// VUE_APP_CHAT_WEBSOCKET=ws://10.1.1.12:8000
// VUE_APP_CHAT_URL=http://10.1.1.12:8000/api/v1/
// VUE_APP_CHAT_TYPE=aica
// VUE_APP_LANG=pl

export const BASE_URL = 'https://izbus-sso.aica.chat/api/v1'
export const APP_URL = 'https://izbus-core.aica.chat'
export const CAPTCHA_SITE_KEY = '6LcZuMInAAAAAK8FEX_cFl6cPwC35DTZWaoLAOFh'
